// Holds user-created experiences fetched from the backend. Populated ONCE at
// boot (before the registry resolves) so ?exp=<id> can open a custom project.
const API = process.env.REACT_APP_BACKEND_URL;

let DYNAMIC = [];

export function getDynamic() {
  return DYNAMIC;
}

export async function loadDynamicExperiences() {
  try {
    const res = await fetch(`${API}/api/experiences`);
    const data = await res.json();
    DYNAMIC = Array.isArray(data.experiences) ? data.experiences : [];
  } catch (e) {
    DYNAMIC = [];
  }
  return DYNAMIC;
}
